import { convertBlobToBase64 } from '../../../../utils/file'

import {
  ACCEPTED_IMAGE_TYPES,
  INLINE_IMAGE_SINGLE_FILE_COUNT,
} from './useEditorAddFile.constants'

function isInlineImageType(file) {
  return Object.keys(ACCEPTED_IMAGE_TYPES).includes(file.type)
}

function isInlineImageTooLarge({ file, maxSize }) {
  return file.size > maxSize
}

function isInlineImageEditorAvailable(editor) {
  return Boolean(editor) && !editor.removed
}

async function toInlineImage(file) {
  return {
    base64: await convertBlobToBase64(file),
    blob: file,
    name: file.name,
  }
}

export function isInlineImageInsertable({ attributes, editor }) {
  return Boolean(attributes) && isInlineImageEditorAvailable(editor)
}

export async function getInlineImageBase64Attributes(file) {
  return { src: file.base64 ?? (await convertBlobToBase64(file.blob)) }
}

export function getInlineImageDropFiles({ files, maxSize, multiple }) {
  const { acceptedFiles, tooLargeFileNames } = files
    .filter(isInlineImageType)
    .reduce(
      (accumulator, file) => {
        if (isInlineImageTooLarge({ file, maxSize })) {
          accumulator.tooLargeFileNames.push(file.name)
        } else {
          accumulator.acceptedFiles.push(file)
        }

        return accumulator
      },
      { acceptedFiles: [], tooLargeFileNames: [] }
    )

  return {
    acceptedFiles: multiple
      ? acceptedFiles
      : acceptedFiles.slice(0, INLINE_IMAGE_SINGLE_FILE_COUNT),
    tooLargeFileNames,
  }
}

export function toInlineImages(files) {
  return Promise.all(files.map(toInlineImage))
}
